"use client";

import { Core } from "@faire/design-tokens";
import { SignupFormContainer } from "@faire/retailer-visitor-shared/views/SignUp/_components/CommonStyles";
import { UpsellContainer } from "@faire/retailer-visitor-shared/views/SignUp/_components/upsell-template/UpsellContainer";
import { UpsellLayout } from "@faire/retailer-visitor-shared/views/SignUp/_components/upsell-template/UpsellLayout";
import { useSignUpUPLT } from "@faire/retailer-visitor-shared/views/SignUp/_hooks/useSignUpUPLT";
import { useIsVerticalizedSignUp } from "@faire/retailer-visitor-shared/views/SignUp/_verticalized-signup/useIsVerticalizedSignUp";
import { OpenWithFaireApplicationForm } from "@faire/retailer-visitor-shared/views/SignUp/open-with-faire/application/__internal__/OpenWithFaireApplicationForm";
import { useSaveRequestAndGoToNextStep } from "@faire/retailer-visitor-shared/views/SignUp/signupStepper";
import { Step } from "@faire/retailer-visitor-shared/views/SignUp/Step";
import { useHandleOwFSkip } from "@faire/retailer-visitor-shared/views/SignUp/useHandleOwFSkip";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";

export const OwFApplicationStep = () => {
  const { saveAndGoToNextStep } = useSaveRequestAndGoToNextStep(
    Step.OWF_APPLICATION
  );
  const verticalizedImageryInSignUp = useIsVerticalizedSignUp();
  useSignUpUPLT({ step: Step.OWF_APPLICATION });

  const handleSkip = useHandleOwFSkip();

  const handleContinue = () => {
    saveAndGoToNextStep(undefined);
  };

  if (verticalizedImageryInSignUp) {
    return (
      <SignupFormContainer>
        <Column align="center">
          <OpenWithFaireApplicationForm
            onSkip={handleSkip}
            onSubmit={handleContinue}
          />
        </Column>
      </SignupFormContainer>
    );
  }

  return (
    <UpsellLayout backgroundColor={Core.surface.info}>
      <UpsellContainer>
        <Column align="center">
          <OpenWithFaireApplicationForm
            onSkip={handleSkip}
            onSubmit={handleContinue}
          />
        </Column>
      </UpsellContainer>
      <Spacer height={{ mobileAndAbove: "4x", tabletAndAbove: "5x" }} />
    </UpsellLayout>
  );
};
